/**
 * Quiz→booking attribution marker (AHD-8497). Single source for the
 * `utm_source=quiz&utm_medium=onsite` params every result-page booking link
 * carries: the booking app (ahead-booking-new) captures `utm_*` into
 * `first_url_params` and derives its session source from `utm_source`, so
 * quiz-originated bookings become attributable with no booking-repo change.
 */
export function withQuizAttribution(url: string): string {
  const withSource = new URL(url)
  withSource.searchParams.set("utm_source", "quiz")
  withSource.searchParams.set("utm_medium", "onsite")
  return withSource.toString()
}
